import { Container, Grid, Image, Parse, Section } from '@/components/Core'
import { Button } from '@/components/Ui'
import { Lib } from '@/types'
import clsx from 'clsx'
import { memo } from 'react'
import SectionPartnersFragment from './query'

export interface SectionPartnersProps {
  data: Lib.FragmentOf<typeof SectionPartnersFragment>
}

const SectionPartners = ({ data }: SectionPartnersProps) => {
  const {
    sectionPadding,
    partners,
    hide,
    bg,
    title,
    description,
    _modelApiKey
  } = data

  const N = partners.length

  const sectionClass = clsx(
    'py-section-md',
    hide && 'hidden',
    bg && 'bg-neutral-300'
  )

  return (
    <Section
      className={sectionClass}
      padding={sectionPadding}
      sectionName={_modelApiKey}
      anim="section-fade-in"
    >
      {(title || description) && (
        <Container>
          <Grid>
            <div className="gap-2xl col-span-12 flex flex-col items-start md:col-span-10 md:col-start-2">
              {title && <h2 className="title">{title}</h2>}
              {description && (
                <div>
                  <Parse html={description} />
                </div>
              )}
            </div>
          </Grid>
        </Container>
      )}
      <Container className="mt-2xl">
        <Grid>
          <div className="col-span-12 md:col-span-10 md:col-start-2">
            <div
              className={clsx(
                '',
                N === 1 && '',
                N > 1 &&
                  'gap-2xl grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3'
              )}
            >
              {partners.map((partner, k) => (
                <div
                  key={k}
                  className={clsx(
                    '',
                    N === 1 &&
                      'gap-y-md gap-2xl pb-lg grid items-center justify-between border-b border-neutral-500 md:grid-cols-[1fr_2fr]',
                    N > 1 &&
                      'gap-y-md flex flex-col items-start justify-between'
                  )}
                >
                  <span className="relative aspect-[5/2] w-full max-w-80">
                    <Image
                      data={partner.logo}
                      imgClassName="object-contain"
                      fitWrap
                      isClient={true}
                    />
                  </span>
                  <span className="gap-sm flex flex-col items-start justify-between">
                    {N === 1 && (
                      <>
                        {partner.name && (
                          <h3 className="text-style-large">{partner.name}</h3>
                        )}
                        {partner.description && (
                          <Parse html={partner.description} />
                        )}
                      </>
                    )}
                    {partner.link ? (
                      <Button
                        href={partner.link || undefined}
                        target="_blank"
                        rel="noopener noreferrer"
                        icon="lucide:arrow-up-right"
                        className="!px-0 text-black"
                        variant="ghost"
                      >
                        {partner.linkText}
                      </Button>
                    ) : (
                      <span className="text-neutral-500">
                        {partner.linkText}
                      </span>
                    )}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </Grid>
      </Container>
    </Section>
  )
}

export default memo(SectionPartners)
